// GreyOut Keyword
window.onload = function () {
  greyKeyword();
  searchBoxInput();
};

let custom_selector = document.querySelector(".selector");
let selector_container = document.querySelector(".selector-container");
let browse_content = document.querySelector(".browse_content");
if (custom_selector) {
  custom_selector.onclick = function () {
    if (
      selector_container &&
      !selector_container.classList.contains("selector-open")
    ) {
      selector_container.classList.add("selector-open");
    } else {
      selector_container.classList.remove("selector-open");
    }
  };
}

let allkeys = document.querySelectorAll(".selector-container ul li");
let search_popup = document.querySelector(".constructs-popup");
let search_popup_inner = document.querySelector(".constructs-popup-content");
let search_input = document.querySelector(
  ".constructs-popup-content .search-part input[type=search]"
);
let search_char = document.querySelector(".search-characters");

// GreyOut Keyword
function greyKeyword() {
  var myHeaders = new Headers();
  myHeaders.append("fetch", "filterDocs");
  myHeaders.append("Content-Type", "application/json");

  const titleText = document.querySelector(
    ".product__title h1"
  ).textContent;
  let newtitleText = titleText;

  // const bookName =
  //   "Blockchain-Based Marriage Certificates %26 Domestic Agreements";

  // const bookName2 = "The Love Uncertainty Principle";

  const keywords = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
  ];

  let name = newtitleText;

  // if (bookName === newtitleText) {
  //   name = bookName;
  // } else if (bookName2 === newtitleText) {
  //   name = bookName2;
  // }

  var raw = JSON.stringify({
    value: "BookTitle",
    name: name,
    select: "Term,Content",
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  fetch("https://valuableintelligence.com/a/customService", requestOptions)
    .then((response) => response.text())
    .then((data) => {
      const searchCharArray = JSON.parse(data);
      console.log(searchCharArray);
      const selectiveKeys = document.getElementsByClassName("key");
      var resp = "<ul>";
      var newarr = [];
      for (let i = 0; i < keywords.length; i++) {
        var res = searchCharArray.searchChar.includes(
          keywords[i].toLowerCase()
        );

        if (res) {
          resp += "<li>" + keywords[i] + "</li>";

          if (selectiveKeys[i]) {
            selectiveKeys[i].classList.remove("disabled");
          }
        } else {
          if (selectiveKeys[i]) {
            resp += "<li class='disabled'>" + keywords[i] + "</li>";
            selectiveKeys[i].classList.add("disabled");
          }
        }
      }

      resp += "</ul>";

      // console.log(resp);
    })
    .catch((error) => console.log("error", error));
}

// GreyOut Keyword end

// Lexicon Search
let update_result = (search_input) => {
  if (search_input.replace(" ", "") != "") {
    const predictiveSearchSection = document.querySelector(
      ".constructs-popup-content [data-predictive-search]"
    );
    const predectiveSearchHeader = document.querySelector(
      ".constructs-popup-inner .predictive-search--header"
    );

    predectiveSearchHeader.innerHTML =
      '<div class="custom_loading"><svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div>';
    let SearchResult = document.querySelector(
      "#shopify-section-custom-predictive"
    );
    let requestResponse;
    SearchResult && (SearchResult.innerHTML = "");
    predectiveSearchHeader && predectiveSearchHeader.classList.add("loading");

    var myHeaders = new Headers();
    myHeaders.append("fetch", "searchDocs");
    myHeaders.append("Content-Type", "application/json");

    const titleText = document.querySelector(
      ".product__title h1"
    ).textContent;
    let newtitleText = titleText.replace("&", "%26");

    // const bookName =
    //   "Blockchain-Based Marriage Certificates %26 Domestic Agreements";
    // const bookName2 = "The Love Uncertainty Principle";

    let name = newtitleText;

    // if (bookName === newtitleText) {
    //   name = bookName;
    // } else if (bookName2 === newtitleText) {
    //   name = bookName2;
    // }

    var raw = JSON.stringify({
      value: "BookTitle",
      name: name,
      select: "BookTitle,Term,Content,ChapterTitle,Author,Thumbnail,URL",
      searchString: search_input,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };
    fetch("https://valuableintelligence.com/a/customService", requestOptions)
      .then((response) => {
        requestResponse = response;
        return response.json();
      })
      .then((text) => {
        if (!requestResponse.ok) {
          throw new Error(`${requestResponse.status}: ${text}`);
        }
        // console.log(text, "========53");
        var responce = "";
        if (text.length > 0) {
          responce += "<div id='predictive-search-results'><ul>";
        }
        let predictiveSearchSection = document.querySelector(
          ".constructs-popup-content .dataUpdate"
        );
        for (let index = 0; index < text.length; index++) {
          // responce +=
          //   '<li><a href="#javascript:void(0)" data-id="' +
          //   text[index].Term +
          //   '" class="slide-right">' +
          //   text[index].Term +
          //   "</a>";
      responce +=
        '<li><a href="javascript:void(0)" data-id="' +
        text[index].Term.replace(/’|‘|�/g, "'") + // Replace curly quotes and special characters with standard single quotes
        '" class="slide-right">' +
        text[index].Term.replace(/’|‘|�/g, "'") + // Replace for the displayed text
        "</a>";
          responce += '<div class="article_content">';
          responce += '<div class="article_header">';
          responce +=
          '<div class="article_heading">' +
          text[index].Term.replace(/’|‘|�/g, "'") + // Replace curly quotes and special characters with standard single quotes
          "</div>";

          responce += '<a class="article_close" href="javascript:void(0)">';
          responce +=
            '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">';
          responce +=
            '<path d="M16.859 1.50684L1.66992 16.6959" stroke="black" stroke-width="1.5189" stroke-linecap="round" stroke-linejoin="round"></path>';
          responce +=
            '<path d="M1.66992 1.50684L16.859 16.6959" stroke="black" stroke-width="1.5189" stroke-linecap="round" stroke-linejoin="round"></path>';
          responce += "</svg>";
          responce +=
            '</a></div><div class="article_body">' +
            text[index].Content +
            "</div>";

          responce +=
            '<a class="article_addon-link" href="' + text[index].URL + '">';
          responce +=
            '<figure><img src="' + text[index].Thumbnail + '"></figure>';
          responce += '<div class="article_addon-content">';
          responce +=
            "<p class='modalHeading'>" + text[index].ChapterTitle + "</p>";
          responce += "<p class='modalTitle'>" + text[index].BookTitle + "</p>";
          responce +=
            "<span><u><i> Author: " + text[index].Author + "</i></u></span>";
          responce +=
            '</div></a><div class="closeBtn"><a class="article_close redbtn" href="javascript:void(0);" close-modal><img src="https://cdn.shopify.com/s/files/1/0772/2614/8156/files/Frame_781.svg?v=1707403126"> Close Window</a></div>';

          responce += "</div> </li>";
        }

        if (text.length > 0) {
          responce += "</ul></div>";
        } else {
          responce += "<p> No Record Available! </p>";
        }

        // predectiveSearchHeader &&
        //   predectiveSearchHeader.classList.remove("loading");

        predectiveSearchHeader &&
          predectiveSearchHeader.classList.remove("loading");
        jQuery(".dataUpdate").html(responce);
        // predictiveSearchSection.innerHTML = responce;
      })
      .catch((error) => {});
  }
};

function getSearchResult(termName) {
  var myHeaders = new Headers();
  myHeaders.append("fetch", "filterDocs");
  myHeaders.append("Content-Type", "application/json");
  var raw = JSON.stringify({
    value: "BookTitle",
    name: "Blockchain-Based Marriage Certificates %26 Domestic Agreements",
    select: "Term,Content,ChapterTitle",
    termName: termName,
  });

  var requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };
  fetch("https://valuableintelligence.com/a/customService", requestOptions)
    .then((response) => {
      requestResponse = response;
      return response.json();
    })
    .then((text) => {
      if (!requestResponse.ok) {
        throw new Error(`${requestResponse.status}: ${text}`);
      }
    });
}

search_input.addEventListener("keyup", function () {
  update_result(search_input.value);
  if (search_char) {
    search_char.innerHTML = search_input.value + ":";
  }
});

if (allkeys.length) {
  allkeys.forEach((key) => {
    key.onclick = function () {
      if (search_popup && !search_popup.classList.contains("popup-open")) {
        search_popup.classList.add("popup-open");
        update_result(key.dataset.value);
        search_input.value = "";
        if (
          document.querySelector(
            ".constructs-popup-content predictive-search li.active"
          )
        ) {
          document
            .querySelector(
              ".constructs-popup-content predictive-search li.active"
            )
            .classList.remove("active");
        }
        document
          .querySelector(".constructs-popup-content predictive-search")
          .classList.remove("slided");
        document.querySelector(
          ".constructs-popup-content"
        ).style.height = `auto`;
        if (search_char) {
          search_char.innerHTML = key.dataset.value + ":";
        }
      }
    };
  });
}

document.addEventListener("click", function (event) {
  if (
    browse_content &&
    selector_container.classList.contains("selector-open")
  ) {
    if (!browse_content.contains(event.target)) {
      selector_container.classList.remove("selector-open");
    }
  }

  if (search_popup_inner && search_popup.classList.contains("popup-open")) {
    if (
      (!search_popup_inner.contains(event.target) &&
        search_popup.contains(event.target)) ||
      event.target.classList.contains("popup-close")
    ) {
      search_popup.classList.remove("popup-open");
    }
  }

  if (event.target.classList.contains("slide-right")) {
    document
      .querySelector(".constructs-popup-content predictive-search")
      .classList.add("slided");
    event.target.parentElement.classList.add("active");
    let content_height = event.target.parentElement
      .querySelector(".article_content")
      .getBoundingClientRect().height;
    document.querySelector(
      ".constructs-popup-content"
    ).style.height = `${content_height}px`;
    window.onresize = function () {
      if (
        document
          .querySelector(".constructs-popup-content predictive-search")
          .classList.contains("slided")
      ) {
        let content_height = event.target.parentElement
          .querySelector(".article_content")
          .getBoundingClientRect().height;
        document.querySelector(
          ".constructs-popup-content"
        ).style.height = `${content_height}px`;
      }
    };
  }
  if (event.target.classList.contains("article_close")) {
    document
      .querySelector(".constructs-popup-content predictive-search li.active")
      .classList.remove("active");
    document
      .querySelector(".constructs-popup-content predictive-search")
      .classList.remove("slided");
    document.querySelector(".constructs-popup-content").style.height = `auto`;
  }
});

// Search Box Input

let searchInput = document.querySelector(".search-input");
let titles = document.querySelectorAll(".main .title");
let searchTerm = "";
let tit = "";

function search(e) {
  searchTerm = e.target.value.toLowerCase();

  titles.forEach((title) => {
    tit = title.textContent.toLowerCase();
    tit.includes(searchTerm)
      ? (title.style.display = "block")
      : (title.style.display = "none");
  });
}

searchInput.addEventListener("keyup", search);

let searchResultBox = document.querySelector(".search-result-box");
let searchResultBoxResult = document.getElementById("search-keyword");

searchInput.addEventListener("click", function (a) {
  searchResultBox.classList.add("sussion");
  a.stopPropagation();
});

document.body.addEventListener("click", function (e) {
  if (!e.target.closest(".modal") && !e.target.matches(".search-input")) {
    searchResultBox.classList.remove("sussion");
  }
});

function capitalizeFLetter(string) {
  // let res = string[0].toUpperCase() + string.slice(1);
  let res = string[0].toUpperCase();
  return res;
}

function searchBoxInput() {
  const searchInputTerm = document.getElementById("myInput");
  var data;
  let requestResponse;

  searchInputTerm.addEventListener("keyup", async (event) => {
    event.preventDefault();

    // const data = new FormData(searchInputTerm);
    // const inputDataValue = Array.from(data);

    const inputValue = document.getElementById("myInput").value;
    // console.log(inputValue, "input value");

    if (inputValue.length >= 3) {
      document.getElementById("search-keyword").style.display = "block";
      var myHeaders = new Headers();
      myHeaders.append("fetch", "searchDocs");
      myHeaders.append("Content-Type", "application/json");

      const titleText = document.querySelector(
        ".season-heading.main-title h2"
      ).textContent;
      let newtitleText = titleText;

      // const bookName =
      //   "Blockchain-Based Marriage Certificates %26 Domestic Agreements";
      // const bookName2 = "The Love Uncertainty Principle";

      let name = newtitleText.replace("&", "%26");

      // if (bookName === newtitleText) {
      //   name = bookName;
      // } else if (bookName2 === newtitleText) {
      //   name = bookName2;
      // }
      var serachString = capitalizeFLetter(inputValue);

      console.log("459", name);

      var raw = JSON.stringify({
        value: "BookTitle",
        name: name,
        select:
          "BookTitle,Term,Content,ChapterTitle,Author,Thumbnail,URL,Summary,ChapterTitle",
        searchString: serachString,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      fetch("https://valuableintelligence.com/a/customService", requestOptions)
        .then((response) => {
          requestResponse = response;

          if (inputValue.length >= 3) {
            return response.json();
          }
          // console.log(requestResponse.value, "=======425s");

          // const contentType = response.headers.get("content-type");
          // if (contentType && contentType.includes("application/json")) {
          //   return response.json();
          // } else {
          //   throw new Error("Response is not in JSON format");
          // }
        })
        .then((text) => {
          if (!requestResponse.ok) {
            throw new Error(`${requestResponse.status}: ${text}`);
          }
          updateSearchResults(text, inputValue);
          // console.log(text, "========437");
        })
        .catch((error) => console.log("error", error));
    } else {
      var searchKeywordElement = document.getElementById("search-keyword");
      if (searchKeywordElement) {
        var ulElement = searchKeywordElement.querySelector("ul");
        if (ulElement) {
          searchKeywordElement.removeChild(ulElement);
        }
      }
    }
  });
}

function countSiblingsAfterClass(className) {
  var elementsWithClass = document.getElementsByClassName(className);
  if (elementsWithClass.length > 0) {
    var targetElement = elementsWithClass[0];
    var count = 0;
    while (targetElement.nextElementSibling) {
      count++;
      targetElement.nextElementSibling.remove();
    }
    return count;
  } else {
    return 0;
  }
}

function updateSearchResults(text, inputDataValue) {
  var responseContainer = document.getElementById("search-keyword");
  var mainContainer = document.getElementById("main-box");
  var numberOfSiblings = countSiblingsAfterClass("main-box");
  if (!responseContainer) {
    console.error("Container not found");
    return;
  }

  var responce = "";
  let modalResp = "";
  let matchingResultFound = false;
  responseContainer.innerHTML = "";
  if (text.length > 0) {
    responce += "<ul>";

    // Display matched results
    for (let index = 0; index < text.length; index++) {
      // Check if the search term is present in the current item's Term
      if (
        text[index].Term.toLowerCase().indexOf(inputDataValue.toLowerCase()) !==
        -1
      ) {
        matchingResultFound = true;
        responce +=
          '<li class="modal-first-btn" open-modal="modal-' +
          index +
          '">' +
          text[index].Term +
          "</li>";

        modalResp +=
          '<div class="modal product-modal-new" id="modal-' +
          index +
          '"><div class="modal-box"><div class="absolute-popup"><div class="article_content_new"><div class="article_header"><div class="article_heading text-center">' +
          text[index].Term +
          '</div><a class="redbtn btn-cross" href="javascript:void(0)" close-modal><svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.859 1.50684L1.66992 16.6959" stroke="black" stroke-width="1.5189" stroke-linecap="round" stroke-linejoin="round"></path><path d="M1.66992 1.50684L16.859 16.6959" stroke="black" stroke-width="1.5189" stroke-linecap="round" stroke-linejoin="round"></path></svg></a></div><div class="article_body"><p>' +
          text[index].Content +
          '</p></div><div class="articleDeatils"><div class="articleImg"><img src="' +
          text[index].Thumbnail +
          '" alt=""></div><div class="articleText"><h2 class="heading"><a href="' +
          text[index].URL +
          '">' +
          text[index].ChapterTitle +
          '</a></h2><span class="subheading"><a href="' +
          text[index].URL +
          '">' +
          text[index].BookTitle +
          '</a></span><span class="lightGray">Author: <a href="mailto:loremipsum.com">' +
          text[index].Author +
          '</a></span></div></div><div class="closeBtn"><a class="redbtn" href="javascript:void(0);" close-modal><img src="https://cdn.shopify.com/s/files/1/0772/2614/8156/files/Frame_781.svg?v=1707403126"> Close Window</a></div></div></div></div></div>';
      }
    }
    if (!matchingResultFound) {
      responce = "<ul><li> No results match the search </li></ul>";
    }

    responce += "</ul>";
  } else {
    if (!matchingResultFound) {
      responce += "<ul><li> No results match the search </li></ul>";
    }
  }

  document.getElementById("main-box").style.display = "flex";
  responseContainer.innerHTML = responce;
  mainContainer.insertAdjacentHTML("afterend", modalResp);

  // console.log(text, responce, "========53");

  document.querySelectorAll("[open-modal]").forEach(function (element) {
    element.addEventListener("click", function () {
      var id = element.getAttribute("open-modal");
      document.querySelector(".modal#" + id).classList.add("active");
    });
  });

  document.querySelectorAll("[close-modal]").forEach(function (element) {
    element.addEventListener("click", function () {
      element.closest(".modal").classList.remove("active");
    });
  });

  document.querySelectorAll(".modal").forEach(function (modal) {
    modal.addEventListener("click", function (e) {
      if (e.target === this) {
        modal.classList.remove("active");
      }
    });
  });

  document.addEventListener("click", function (event) {
    var searchResultDiv = document.getElementById("search-keyword");
    var searchBox = document.getElementById("searchBox");

    if (
      event.target !== searchResultDiv &&
      !searchResultDiv.contains(event.target) &&
      event.target !== searchBox &&
      !searchBox.contains(event.target)
    ) {
      searchResultDiv.style.display = "none";
    }
  });

  // Show more content

  $(function () {
    var nav = $(".summary-content"),
      animateTime = 500,
      navLink = $(".show-more-summary");
    navLink.click(function (e) {
      if (e.target.innerHTML == "Show More") {
        e.target.innerHTML = "Show Less";
        e.target.previousElementSibling.style.maxHeight = "fit-content";
      } else {
        e.target.innerHTML = "Show More";
        e.target.previousElementSibling.style.maxHeight = "120px";
      }
      // if (nav.height() === 0) {
      //   autoHeightAnimate(nav, animateTime);
      // } else {
      //   nav.stop().animate({ height: "0" }, animateTime);
      // }
    });
  });

  function autoHeightAnimate(element, time) {
    var curHeight = element.css("height", "120").height(), // Get Default Height
      autoHeight = element.css("height", "auto").height(); // Get Auto Height
    element.height(curHeight); // Reset to Default Height
    element.stop().animate({ height: autoHeight }, time); // Animate to Auto Height
  }
}

// end search input box
